const selectors = {
    cartCheckout: document.querySelector('#cart-checkoutbtn'),
    checkoutSticky: document.querySelector('.checkoutbtn-sticky')
};

class templateCartJS {
    constructor() {
        this.stickyCheckout();
        this.bindCartEvents();
    }

    // Sticky checkout container on page scroll
    stickyCheckout(){
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    selectors.checkoutSticky.classList.remove('active');
                } else {
                    selectors.checkoutSticky.classList.add('active');
                }
            })
        });
            
        observer.observe(selectors.cartCheckout);
    }

    // Bind cart events for remove and quantity updates
    bindCartEvents() {
        // Remove item buttons
        document.querySelectorAll('[data-item-remove]').forEach(button => {
            button.addEventListener('click', this.removeItem.bind(this));
        });

        // Quantity buttons
        document.querySelectorAll('[data-qty-btn]').forEach(button => {
            button.addEventListener('click', this.manageQtyBtn.bind(this));
        });

        // Quantity input changes
        document.querySelectorAll('[data-qty-input]').forEach(input => {
            input.addEventListener('keyup', (e) => {
                if(e.key === 'Enter' || e.keyCode === 13) {
                    this.onQtyChange(e);
                }
            });
        });
    }

    // Remove item from cart
    async removeItem(event) {
        event.preventDefault();
        
        const button = event.currentTarget;
        const itemIndex = button.getAttribute('data-index');
        const cartItem = button.closest('[data-cart-item]');
        
        if (cartItem) {
            cartItem.classList.add('updating');
        }

        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: cartItem.dataset.variantId,
                    quantity: 0
                })
            });

            if (response.ok) {
                // Reload the page to show updated cart
                window.location.reload();
            } else {
                console.error('[Cart] Failed to remove item', response.status);
                if (cartItem) {
                    cartItem.classList.remove('updating');
                }
                if (window.notificationEle) {
                    window.notificationEle.updateNotification('Cart', 'Could not remove item. Please try again.', { type: 'error', timeout: 5000 });
                }
            }
        } catch (error) {
            console.error('[Cart] Error removing item', error);
            if (cartItem) {
                cartItem.classList.remove('updating');
            }
            if (window.notificationEle) {
                window.notificationEle.updateNotification('Cart', 'Something went wrong. Please try again.', { type: 'error', timeout: 5000 });
            }
        }
    }

    // Handle quantity button clicks
    manageQtyBtn(event) {
        event.preventDefault();
        
        const button = event.currentTarget;
        const action = button.getAttribute('data-for');
        const qtyInput = button.closest('.quantity-wrapper').querySelector('[data-qty-input]');
        let currentQty = parseInt(qtyInput.value);
        
        if (action === 'increase') {
            currentQty++;
        } else if (action === 'decrease' && currentQty > 1) {
            currentQty--;
        }
        
        qtyInput.value = currentQty;
        this.onQtyChange(event);
    }

    // Handle quantity input changes
    async onQtyChange(event) {
        const input = event.currentTarget;
        const cartItem = input.closest('[data-cart-item]');
        const variantId = cartItem.dataset.variantId;
        const newQty = parseInt(input.value);
        
        if (cartItem) {
            cartItem.classList.add('updating');
        }

        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: newQty
                })
            });

            if (response.ok) {
                // Reload the page to show updated cart
                window.location.reload();
            } else {
                console.error('[Cart] Failed to update quantity', response.status);
                if (cartItem) {
                    cartItem.classList.remove('updating');
                }
                if (window.notificationEle) {
                    window.notificationEle.updateNotification('Cart', 'Could not update quantity. Please try again.', { type: 'error', timeout: 5000 });
                }
            }
        } catch (error) {
            console.error('[Cart] Error updating quantity', error);
            if (cartItem) {
                cartItem.classList.remove('updating');
            }
            if (window.notificationEle) {
                window.notificationEle.updateNotification('Cart', 'Something went wrong. Please try again.', { type: 'error', timeout: 5000 });
            }
        }
    }
}

// Initialize cart functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('#cart--items')) {
        new templateCartJS();
    }
});
